import { useEffect, useState } from 'react';
import { getTotalEmailSentByWorkspaceId } from 'wisestep-api';

import { IMISAnalyticsQuery } from '../../IMISAnalyticsQuery';

import CustomCountWithTextCard from './CustomCountWithTextCard';

const TotalEmailsSent = ({ query }: IMISAnalyticsQuery) => {
  const [totalEmails, setTotalEmails] = useState<number>(0);
  useEffect(() => {
    const fetchData = async () => {
      const response = await getTotalEmailSentByWorkspaceId(query);
      setTotalEmails(response.data ?? 0);
    };
    fetchData();
  }, [query]);

  return (
    <CustomCountWithTextCard
      count={totalEmails}
      text="Total number of Emails sent from Platform - Lifetime"
    />
  );
};

export default TotalEmailsSent;
